<template>
  <v-app>
    <main>
      <v-container fluid fill-height>  
            
          <v-flex sm1 md3> 
          </v-flex>
          <v-flex  sm7 md5>
            <v-card class="elevation-12">
              <v-toolbar  flat dense color="#088BD1">
                <v-toolbar-title class="white--text">Calculadora Financiera</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
            <v-card-text> 
              
              <v-form> 
                <v-flex xs7>
                   <v-text-field 
                    v-model="sal"
                    label="Ingrese Salario"
                    :rules="numberRules"
                    placeholder="000.00"
                  ></v-text-field>
                     <br>
                  <v-combobox
                    :items="gen"
                    v-model="gene"
                    label="Selecionar género"
                    :rules="generalRule"
                  ></v-combobox>
                    
                  <v-combobox
                    :items="sect"
                    v-model="sectl"
                    label="Situación Laboral"
                    :rules="generalRule"
                  ></v-combobox>
                    <br>
                  <v-text-field 
                   v-model="porc"
                    class="mt-0"
                    type="number"
                    prefix="%"
                    step="1"
                    hint="Porcentaje mensual que sera descontado de su salario"
                    min="2"
                    label="Aporte mensual"
                    :rules="generalRule"
                    max="100"
                ></v-text-field>
                <p  class="text-lg-right"> Aporte Aproximado: {{porcaporte}}</p>
                     
                    <br>
                <v-text-field 
                   v-model="ren"
                   class="mt-0"
                   type="number"
                   prefix="%"
                   step="0.5"
                   hint="Comprende los intereses devengados y el precio de mercado de los títulos o valores del portafolio de inversiones."
                   min="0"
                   label="Rendimiento neto"
                   :rules="generalRule"
                   max="6"
                ></v-text-field>
                <br>
                <v-text-field 
                   v-model="edad"
                   class="mt-0"
                    type="number"
                    step="1"
                    hint="Ingrese su edad para calcular una proyeccion desde su edad actual hasta su retiro"
                    min="18"
                    label="Edad"
                    max="62"
    
               ></v-text-field>
               <small style="color:red;">{{valdr}}</small>
            <br>
             <v-text-field 
                  v-model="apch"
                  label="Aportes hasta la fecha"
                  placeholder="000.00"
                  :rules="numberRules"
                  hint="Ingrese la cantidad actual de sus aportes(0 si no posee)"
                  ></v-text-field>
          <v-card-actions>
            <v-btn color="#79c5ee"
              @click="dialog=true"
              slot="activator" >Calcular</v-btn>
          </v-card-actions>
      </v-flex>
      </v-form>
        </v-card-text>
              
          </v-card>
            
          </v-flex>        
      </v-container>
      <!--Dialog-->
        <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-card>
         <v-toolbar flat dense
         color="#088BD1">
          <v-toolbar-title  class="white--text">Proyección de Saldo</v-toolbar-title>
         </v-toolbar>

        <v-card-text>
          <h4 style="color:red">Incentivo que aporta el estado (0.3%): {{$data.aestado}}</h4>
          <br>
          <h3> {{$data.subt1}} (Proyección saldo a la fecha)</h3>
          <h3><u> {{$data.subt2}} (Proyección Aporte Mensual)</u></h3>
          <h3 style="color:green"> total: {{calcper(porcaporte)}} </h3>
          <br>
          <small>En un período de: {{$data.per}} años</small>
          <br>     
          <small style="text-center">Proyección Apróximada en base a los últimos rendimientos del sistema.</small>
             <br>
             <div id="chartdiv" style="width: 100%; height: 400px;">
               {{graphs}}
             </div>
         <small style="color:red">Nota: Este es un cálculo aproximado a lo que podría ser su saldo real, ya que otros factores podrian
           influir en el aumento o disminución del mismo.
         </small>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            flat
            @click="dialog = false"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </main>
  </v-app>
</template>



<script>
  export default {
    data () {
      return {
      gen: ['Masculino','Femenino'],
      sect: ['Servidor Público', 'Ex-Servidor'],
      numberRules: [ v => !!v || 'Campo es requerido (Valor númerico)',
                     v => !isNaN(v)|| 'EL valor debe ser númerico'],
      porc: "", edad: "",sal: "",ren: "",sectl:"",gene:"",apch:"",per:"", msg:"",tot1:"",tot2:"",
      tot3:"",tot4:"", aestado:"",subt1:"",subt2:"",
      generalRule:[  v => !!v || 'Información requerida'],
      
      dialog: false
      }
    },
    //Grafico
    computed: {
      valdr(){
        if ((this.edad >= 62 & this.gene=="Masculino" )|| (this.edad >=57 & this.gene=="Femenino") || this.edad <18 || this.edad >62 ){
         this.edad=""
         return this.msg="Ingrese la edad dentro de los rangos"
        }
      },
      graphs(){
      AmCharts.makeChart("chartdiv", {
      "type": "serial",
      "theme": "light",
      "marginRight": 70,
      "dataProvider": [{
      "Porcentaje": "Último mes(4.5381 %)",
      "visits": this.tot2,
      "color": "#90d8f7"
      }, {
    "Porcentaje": "Último 6 meses (2.5948 %)",
    "visits": this.tot3,
    "color": "#008bd1"
    }, {
    "Porcentaje": "Últimos 12 meses (2.9852 %)",
    "visits": this.tot4,
    "color": "#90d8f7"
    }, {
    "Porcentaje": "Histórico (6.5456 %)",
    "visits": this.tot1,
    "color": "#008bd1"
  
  }, 
  ],
  "valueAxes": [{
    "axisAlpha": 0,
    "position": "left",
    "title": "Proyección Estimada (Balboas)"
  }],
  "startDuration": 1,
  "graphs": [{
    "balloonText": "<b>[[category]]: [[value]]</b>",
    "fillColorsField": "color",
    "fillAlphas": 0.9,
    "lineAlpha": 0.2,
    "type": "column",
    "valueField": "visits"
  }],
  "chartCursor": {
    "categoryBalloonEnabled": false,
    "cursorAlpha": 0,
    "zoomable": false
  },
  "categoryField": "Porcentaje",
  "categoryAxis": {
    "gridPosition": "start",
    "labelRotation": 45
  },
  "export": {
    "enabled": true
  }

});
    },
      porcaporte()
      {
        if (isNaN(this.sal ) || isNaN(this.porc))
        { 
          this.sal=null;  this.porc=null;
         }
         else
         { 
       var total = this.porc/100 * this.sal
       return total.toFixed(2)
         }
      },
    },
    methods: {
        calcper: function(apm)
        {  var ran =this.ren/100 
           var rh= 6.5/100
           var r1= 4.53/100
           var r2= 2.59/100
           var r3 = 2.98/100
          var perm=0
          if(this.gene=="Masculino"){
            perm= 62-this.edad
          }
          else if(this.gene=="Femenino"){
             perm= 57-this.edad
          }
          this.per= perm
          perm=perm*12
          if(this.sectl=="Servidor Público"){
              var apg= this.sal*0.003
              this.aestado=apg.toFixed(2)
              var taporte= parseInt(apm) + apg
              //Rendimiento Escogido por el Usuario
              var tsal_f=this.apch*((Math.pow(1+(ran/12),perm)));
              this.subt1=tsal_f.toFixed(2)
              var total= (parseFloat(taporte) *((Math.pow(1+(ran/12),perm))-1)/(ran/12))+tsal_f;
              total=total.toFixed(2)
              this.subt2=(parseFloat(taporte) *((Math.pow(1+(ran/12),perm))-1)/(ran/12)).toFixed(2)
              //Rendmiento Historico
              var tsal_f=this.apch*((Math.pow(1+(rh/12),perm)));
              this.tot1= ((parseFloat(taporte) *((Math.pow(1+(rh/12),perm))-1)/(rh/12))+tsal_f).toFixed(2);
              //Rendmiento Ultimo mes
              var tsal_f=this.apch*((Math.pow(1+(r1/12),perm)));
              this.tot2= ((parseFloat(taporte) *((Math.pow(1+(r1/12),perm))-1)/(r1/12))+tsal_f).toFixed(2);
              //Rendmiento Ultimo 6 meses
              var tsal_f=this.apch*((Math.pow(1+(r2/12),perm)));
              this.tot3= ((parseFloat(taporte) *((Math.pow(1+(r2/12),perm))-1)/(r2/12))+tsal_f).toFixed(2);
              //Rendmiento Ultimo 12 meses
              var tsal_f=this.apch*((Math.pow(1+(r3/12),perm)));
              this.tot4= ((parseFloat(taporte) *((Math.pow(1+(r3/12),perm))-1)/(r3/12))+tsal_f).toFixed(2);
          }
          else if (this.sectl=="Ex-Servidor"){
             //rendimiento escojido por usuario
              this.aestado=0
              var tsal_f=this.apch*((Math.pow(1+(ran/12),perm)));
              this.subt1=tsal_f.toFixed(2)
              var total= (apm*((Math.pow(1+(ran/12),perm))-1)/(ran/12))+tsal_f;
              total=total.toFixed(2);
              this.subt2=(apm*((Math.pow(1+(ran/12),perm))-1)/(ran/12)).toFixed(2)
              //rendimiento historico 
              var tsal_f=this.apch*((Math.pow(1+(rh/12),perm)));
              this.tot1= ((apm*((Math.pow(1+(rh/12),perm))-1)/(rh/12))+tsal_f).toFixed(2);
              //rendimiento ultimo mes
              var tsal_f=this.apch*((Math.pow(1+(r1/12),perm)));
              this.tot2= ((apm*((Math.pow(1+(r1/12),perm))-1)/(r1/12))+tsal_f).toFixed(2);
              //rendimiento ultimos 6 meses
              var tsal_f=this.apch*((Math.pow(1+(r2/12),perm)));
              this.tot3= ((apm*((Math.pow(1+(r2/12),perm))-1)/(r2/12))+tsal_f).toFixed(2);
             //rendimiento Ultimos 12 meses
              var tsal_f=this.apch*((Math.pow(1+(r3/12),perm)));
              this.tot4= ((apm*((Math.pow(1+(r3/12),perm))-1)/(r3/12))+tsal_f).toFixed(2);
          }
          return total
        }
    },
  }
</script>



// WEBPACK FOOTER //
// src/App.vue